import { render } from "./AdminCategories.vue?vue&type=template&id=57e2010f&scoped=true"
import script from "./AdminCategories.vue?vue&type=script&lang=js"
export * from "./AdminCategories.vue?vue&type=script&lang=js"

import "./AdminCategories.vue?vue&type=style&index=0&id=57e2010f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e2010f"]])

export default __exports__